export default {
  "layout": "HUdfu",
  "cell": "GbNOh"
};